import React from 'react';

import MetaTags from 'components/meta-tags';
import { Card } from './card';
import { IrlEventLogo } from './irl-event-logo';
import { ContentHeader, Heading, Description } from './styles';

const DEFAULT_TITLE = 'This event is unavailable';
const DEFAULT_DESCRIPTION = `We're having trouble loading this event right now. \nPlease try again later.`;

type IrlEventErrorProps = {
  title?: string;
  description?: string;
  children?: React.ReactNode;
};

export function IrlEventError({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  children,
}: IrlEventErrorProps = {}): JSX.Element {
  return (
    <>
      <MetaTags title={title} description={description} />

      <Card data-testid='irl-event-error'>
        <IrlEventLogo headerImageUrl={null} showError />

        <ContentHeader>
          <Heading data-testid='irl-event-error-heading'>{title}</Heading>
          <Description data-testid='irl-event-error-description'>{description}</Description>
        </ContentHeader>

        {children}
      </Card>
    </>
  );
}
